import React, { Fragment, useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '../../../components/Button'
import LoginPagesWrapper from '../../../components/LoginPagesWrapper'
import LinkButton from '../../../components/LinkButton'
import Paper from '@material-ui/core/Paper'
import { withRouter } from 'react-router'
import { checkEmail, requestForgotPasswordEmail, resetEmailStatus } from '../../../redux/actions'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import FormTextField from '../../../components/FormTextField'
import { reduxForm, change, formValueSelector } from 'redux-form'
import { required, passwordMatch, passwordStrength, email } from '../../../utilties/validators'
import Logo from '../../../assets/logo'
import { injectIntl } from 'react-intl'
import queryString from 'query-string'
import { emailStatusSelector, emailValidationInProgressSelector } from '../../../redux/selectors'
import { CircularProgress, FormHelperText, InputAdornment } from '@material-ui/core'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

const useStyles = makeStyles((theme) => ({
	emailValidationNotRegistered: {
	  color: theme.palette.text.primary,
	  display: 'inline',
	},
	emailValidationGoToRegistration: {
		display: 'inline-block',
	},
	emailValidationNotFound: {
		color: theme.palette.error.main,
	}
  }));

const requiredValidator = required
const emailValidator = email

const selector = formValueSelector('forgotPassword')

const ForgotPassword = ({ handleSubmit, intl, submitRequest, checkEmail, resetEmailStatus, emailStatus, emailValidationInProgress, currentEmail, changeEmail }) => {
	
	const classes = useStyles()

	const onSubmitForm = (values) => {
		submitRequest(values.email)
	}

	useEffect(() => {
		const values = queryString.parse(window.location.search)

		if(emailStatus != null) {
			resetEmailStatus()
		}

		if (values.email) {
			changeEmail(values.email)
			checkEmail(values.email)
		}
	}, [])

	return (
		<LoginPagesWrapper
			canChangeLanguage={false}
		>
			<form onSubmit={handleSubmit(onSubmitForm)}
				data-testid='form-forgot'
				style={{ display: 'flex', justifyContent: 'center', width: '90%', margin: '10vh auto 4rem' }}>
				<Paper style={{ maxWidth: '479px', width: '100%', padding: '4rem', margin: '0 auto' }} elevation={2}>
					<Grid item style={{ paddingBottom: '20px', textAlign: 'center' }}>
						<Logo />
					</Grid>
					<Grid item style={{ paddingBottom: '20px', textAlign: 'center' }}>
						<Typography variant="subtitle2">{intl.formatMessage({ id: 'app.forgotPassword.title' })}</Typography>
					</Grid>
					<Grid item style={{ width: '100%' }}>
						<FormTextField
							data-testid='form-forgot-input-email'
							label={intl.formatMessage({ id: 'app.email' })}
							fullWidth
							type="text"
							name="email"
							validators={[requiredValidator, emailValidator]}
							variant="filled"
							onBlur={e => {if(e.target.value) checkEmail(e.target.value)}}
							onChange={() => {if(emailStatus != null) resetEmailStatus()}}
							inputProps={{
								endAdornment:
									emailStatus === 0 || emailStatus === 6
										? <InputAdornment position="end">
											<CheckCircleOutlineIcon style={{ color: 'green', fontSize: '28px' }} />
										</InputAdornment>
										: emailValidationInProgress
											? <CircularProgress size={20} />
											: null
							}}
							customInvalid={emailStatus > 0 && emailStatus !== 6}
						/>
						{emailStatus > 0 && emailStatus !== 6 && (
							<FormHelperText
								error={true}
								data-testid="auth-email-validation-error"
								style={{
									marginTop: '-22px',
									marginBottom: '18px',
								}}>
								{emailStatus === 1 && (
									<Fragment>
										<Typography variant="body2" className={classes.emailValidationNotRegistered}>
											{intl.formatMessage({ id: 'app.auth.emailValidationNotRegistered' })}
										</Typography>
										<Link className={classes.emailValidationGoToRegistration} to={`/auth/register?email=${encodeURIComponent(currentEmail)}`}>
											{intl.formatMessage({ id: 'app.auth.emailValidationGoToRegistration' })}
										</Link>
									</Fragment>)}
								{emailStatus === 2 && (
									<Typography variant="body2" className={classes.emailValidationNotFound}>
									{intl.formatMessage({ id: 'app.auth.emailValidationNotFound' })}
									</Typography>
								)}
							</FormHelperText>
						)}
					</Grid>
					<Grid item style={{ alignSelf: 'flex-start' }}>
						<LinkButton
							data-testid='form-forgot-link-return'
							textId="app.forgotPassword.returnToLoginButtonText"
							variant="contained"
							color="black"
							backgroundColor="#007aff"
							path={currentEmail ? `/auth/login?email=${encodeURIComponent(currentEmail)}` : "/auth/login"}
						/>
					</Grid>
					<Grid item style={{ paddingTop: '20px', textAlign: 'center' }}>
						<Button
							textId="app.forgotPassword.buttonText"
							variant="contained"
							color="primary"
							type="submit"
							data-testid='form-forgot-button-submit'
						/>
					</Grid>
				</Paper>
			</form>
		</LoginPagesWrapper>
	)
}

const mapStateToProps = (state, ownProps) => ({
	emailStatus: emailStatusSelector(state),
	emailValidationInProgress: emailValidationInProgressSelector(state),
	currentEmail: selector(state, 'email')
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	submitRequest: (email) => dispatch(requestForgotPasswordEmail(email)),
	checkEmail: (email) => dispatch(checkEmail(email)),
	resetEmailStatus: () => dispatch(resetEmailStatus()),
	changeEmail: (email) => dispatch(change('forgotPassword', 'email', email))
})

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	injectIntl,
	reduxForm({
		form: 'forgotPassword'
	})
)

export default enhance(ForgotPassword)
